import axios from 'axios';
import store from '@/store';
import config from '@/config';

const API_ENDPOINT = `https://staging.elsanow.co/user/i/api/1/dict`;
const API_EXERCISE_URL = `https://content-check-stag.elsanow.co/content_check_01_exercise`; //`${config.API_ROOT}/exercise-check/`;

export interface IContentCheckError {
  word: string;
  message: string;
  exercise_id: number;
  sentence: string;
  error_level: string;
}

export interface IContentCheckResponse {
  number_errors: number;
  number_warnings: number;
  result: IContentCheckError[];
}

export async function getDictionary(sentence: string = 'screwdriver') {
  try {
    const endpoint = config.API_ROOT + '/dictionary/?sentence=' + sentence;
    console.log(endpoint);

    const { data } = await axios.get(endpoint, {
      headers: {
        'Content-Type': 'application/json',
        'X-Session': store.state.sessionToken
      }
    });

    return data.definitions;
  } catch (err) {
    console.log(err);
    return [];
  }
}
